import Alpine from 'alpinejs';
import AppAnalytics from '../analytics/AppAnalytics';

declare global { interface Window { Alpine: typeof Alpine } }

(document as any).addEventListener('alpine:init', () => {
  Alpine.store('emailCap', {
    // config
    delayMs: 500,
    storageKey: 'doseEmailPromptShown',

    // state
    shown: false,
    visible: false,
    email: '',
    _timer: 0 as unknown as number,

    init() {
      try { this.shown = localStorage.getItem(this.storageKey) === 'true'; } catch {}
      AppAnalytics.getPlausible()
    },

    cancel() {
      if (this._timer) { clearTimeout(this._timer); this._timer = 0 as any; }
    },

    onResult() {
      if (this.shown || this.visible) return;
      this.cancel();
      this._timer = window.setTimeout(() => {
        if (!this.shown) this.visible = true;
      }, this.delayMs);
    },

    dismiss() {
      this.visible = false;
      this.markShown();
      this.cancel();
    },

    markShown() {
      this.shown = true;
      try { localStorage.setItem(this.storageKey, 'true'); } catch {}
    },

    submit() {
      const FREEDOM_CRM_API = 'https://crm.caninehealthcenter.com';
      const FREEDOM_CRM_SITE_ID = 'caninehealthcenter.com';

      // disable / update button label
      const form = document.querySelector('#emailCapForm') as HTMLFormElement | null;
      const btn = form?.querySelector('button[type="submit"]') as HTMLButtonElement | null;
      if (btn) {
        btn.disabled = true;
        btn.dataset.originalText = btn.textContent || '';
        btn.textContent = 'Submitting...';
      }

      fetch(`${FREEDOM_CRM_API}/new-contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: this.email, siteId: FREEDOM_CRM_SITE_ID })
      })
        .then(res => {
          if (!res.ok) throw new Error('Signup failed');
          // success
          this.email = '';
          form?.insertAdjacentHTML('afterend', '<p class="text-green-500 mt-2">You’re in! Check your email soon.</p>');
          setTimeout(() => form?.nextElementSibling?.remove(), 3000);
          this.dismiss();
        })
        .catch(() => {
          form?.insertAdjacentHTML('afterend', '<p class="text-red-500 mt-2">Something went wrong—try again!</p>');
          setTimeout(() => form?.nextElementSibling?.remove(), 3000);
        })
        .finally(() => {
          if (btn) {
            btn.disabled = false;
            btn.textContent = btn.dataset.originalText || 'Subscribe';
          }
        });
    }

  });
});

